module.exports = __webpack_public_path__ + "static/media/lettering-cmu2.766aeac8.jpg";